export default {
  isochronesDetails: {
    'polygons': 'Poligoni',
    'center': 'Centro',
    'reachCenters': 'Centri di sensibilizzazione',
    'toggleVisibility': 'Attiva/disattiva visibilità',
    'opacity': 'Opacità'
  }
}
